import '../styles/Hero.css';
import img1 from '../images/portada/fo2.jpg';

const HERO_BG = img1;

function Hero() {
  return (
    <section
      id="hero"
      className="tm-section tm-hero"
    >
      <div
        className="tm-hero-bg"
        style={{
          backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.7) 100%), url(${HERO_BG})`,
        }}
      />
      <div className="tm-container tm-hero-container">
        <div className="tm-hero-content">
          <div className="tm-hero-badge">
            <span className="material-symbols-outlined tm-hero-badge-icon">star</span>
            The Gold Standard
          </div>
          <h1 className="tm-hero-title">
            SÉ UNA
            <span className="tm-hero-title-italic">Modelo</span>
            <span className="gold-gradient-text" style={{ fontStyle: 'italic' }}>TM</span>
          </h1>
          <p className="tm-hero-description">
            Únete al estudio líder en Cali y transforma tu potencial en una carrera profesional de éxito internacional.
          </p>
          <div className="tm-hero-cta">
            <a
              href="#cta"
              className="btn-hover gold-gradient-bg tm-hero-btn-primary"
            >
              Iniciar Proceso
              <span className="material-symbols-outlined tm-hero-btn-icon">rocket_launch</span>
            </a>
            <a
              href="#beneficios"
              className="btn-hover tm-hero-btn-secondary"
            >
              Conocer Más
              <span className="material-symbols-outlined tm-hero-btn-icon">info</span>
            </a>
          </div>
        </div>
      </div>
      <div className="tm-hero-scroll">
        <span className="tm-hero-scroll-text">Scroll</span>
        <div className="tm-hero-scroll-line" />
      </div>
    </section>
  );
}

export default Hero;

